import React from 'react'
import { motion,    useInView,  } from 'framer-motion';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';



const siliconIndia = () => {
  const MotionCard = {
    hidden: { opacity: 0.5, y: 50,  },
    visible: { opacity: 1, y: 0, 
    transition: { duration: 1, delay: 0.25,  }},

    hiddenMobile: { opacity: 0.5, y: 50,  },
    visibleMobile: { opacity: 1, y: 0, 
    transition: { duration: 1, delay: 0.25,  }},
  }



  const handleClick = () => {
    window.location.href = 'https://consultants.siliconindia.com/ranking/digital-transformation-consultants-2023-rid-1834.html';
  };
  return (
    <>
    <motion.div  
      viewport={{  once: true}}
      variants={MotionCard}
      initial="hidden"
      whileInView="visible"
    onClick={handleClick} className="image-container">
      <img loading='lazy' src="/Images/ContactUs/banner.png" alt="" />
      <div className="contentimg">
      <img loading='lazy' src="/Images/ContactUs/siliconIndia_logo.svg" alt="" />
        <p className='silicon-para1'>Evenion listed in Top 10 promising Digital Transformation Consultants - 2023</p>
        <div className='contact-Readmore'>  
          <a href="/contact-us#contact_form"><span className='btn-liil-mobile'>Read more <ArrowBackIcon className='rotateSilicon' /> </span></a>
        </div>
      </div>
    </motion.div>



    <motion.div  
    viewport={{  once: true}}
    variants={MotionCard}
    initial="hiddenMobile"
    whileInView="visibleMobile"
    onClick={handleClick} className="image-container-mobile">
      <img loading='lazy' src="/Images/ContactUs/banner.png" alt="" />
      <div className="contentimg-mobile">
      <img loading='lazy' src="/Images/ContactUs/siliconIndia_logo.svg" alt="" />
        <p className='silicon-para1-mobile'>Evenion listed in Top 10 promising Digital Transformation Consultants - 2023</p>
        <div className='contact-Readmore-mobile'>  
          <a href="/contact-us#contact_form"><span className='btn-contact-mobile'>Read more <ArrowBackIcon className='rotateSilicon-mobile'/></span></a>
        </div>
      </div>
    </motion.div>
    </>
  )
}

export default siliconIndia